import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { resolveGuideAssetUrl } from "../../utils/resolveGuideAssetUrl";

const Footer = () => {
  return (
    <footer className="footer__container">
      <div className="footer__links">
        <div className="footer__link--wrapper">
          <div className="footer__link--items">
            <h2>About Us</h2>
            <a href="/sign__up">The Project</a>
            <a href="/#why-us">The Team</a>
            <Link to="/terms-of-service">ToS</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
          <div className="footer__link--items">
            <h2>Contact Us</h2>
            <a href="/feedback">Contact</a>
            <a href="/feedback">Feedback</a>
            <a href="/#why-us">Partners</a>
            <a href="https://discord.gg/GrCvYvqFVF" target="_blank" rel="noopener noreferrer">Discord</a>
          </div>
        </div>
        <div className="footer__link--wrapper">
          {/* <div className="footer__link--items">
            <h2>Filler</h2>
            <a href="/">filler 1</a>
            <a href="/">filler 2</a>
            <a href="/">filler 3</a>
            <a href="/">filler 4</a>
          </div> */}
          <div className="footer__link--items">
            <h2>Social Media</h2>
            <Link to="/socials">All socials &amp; updates</Link>
            <a href="https://www.youtube.com/@Valovate" target="_blank" rel="noopener noreferrer">Youtube</a>
            <a href="https://www.twitch.tv/valovate_val" target="_blank" rel="noopener noreferrer">Twitch</a>
            <a href="https://www.instagram.com/valovate_val" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://www.tiktok.com/@valovate_val" target="_blank" rel="noopener noreferrer">TikTok</a>
          </div>
        </div>
      </div>
      <section className="social__media">
  <div className="social__media--wrap">
    <div className="footer__logo">
      <a href="/" id="footer__logo">
        <img
          src={resolveGuideAssetUrl("/assets/valovate_logo_full.svg")}
          alt="Valovate Logo"
          className="footer-logo-img"
        />
      </a>
      <p className="website__rights">
        <em>
          The Valovate Website was created under Riot Games' "Legal Jibber Jabber" policy using assets owned by Riot Games. Riot Games does not endorse or sponsor this project.
        </em>
      </p>

    </div>

    <div className="social__icons">
      <a
        className="social__icon--link"
        href="https://www.instagram.com/valovate_val"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <img
          src={resolveGuideAssetUrl("/assets/SVG-Icons/instagram.svg")}
          alt="Instagram"
          className="social__icon-img"
        />
      </a>

      <a
        className="social__icon--link"
        href="https://www.youtube.com/@Valovate"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Youtube"
      >
        <img
          src={resolveGuideAssetUrl("/assets/SVG-Icons/youtube.svg")}
          alt="YouTube"
          className="social__icon-img"
        />
      </a>

      <a
        className="social__icon--link"
        href="https://x.com/valovate"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X"
      >
        <img
          src={resolveGuideAssetUrl("/assets/SVG-Icons/x_twt.svg")}
          alt="X"
          className="social__icon-img"
        />
      </a>

      <a
        className="social__icon--link"
        href="https://discord.gg/GrCvYvqFVF"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Discord"
      >
        <img
          src={resolveGuideAssetUrl("/assets/SVG-Icons/discord.svg")}
          alt="Discord"
          className="social__icon-img"
        />
      </a>

      <a
        className="social__icon--link"
        href="https://www.twitch.tv/valovate_val"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Twitch"
      >
        <img
          src={resolveGuideAssetUrl("/assets/SVG-Icons/twitch.svg")}
          alt="Twitch"
          className="social__icon-img"
        />
      </a>
    </div>
  </div>
</section>

    </footer>
  );
};

export default Footer;
